;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.bpu.edit')
    .controller('BpuEditToolbarController', BpuEditToolbarController)

  BpuEditToolbarController.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]
  function BpuEditToolbarController (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes

        // Public Method
      })
    }
  }
})(window.angular, window._)
